<template>
  <el-carousel indicator-position="outside" :interval="intervalSpeeds" style="height: 100% !important">
    <el-carousel-item v-for="(item, index) in BackImageLists" :key="index">
      <img :src="item" alt="轮播图" style="width: 100%; height: 100%; object-fit: cover;">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'CarouselCard',
  props: {
    BackImageList: {
      type: Array,
      default: () => []
    },
    intervalSpeed: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      // 可以直接使用 props 的值，不需要复制到 data
      // BackImageLists 已经可以通过 this.BackImageList 直接访问
    };
  },
  computed: {
    // 推荐使用 computed property 替代 watch
    BackImageLists() {
      return this.BackImageList.length > 0 ? this.BackImageList : [
        '',
        ''
      ];
    },
    intervalSpeeds() {
      return this.intervalSpeed || 3000;
    }
  }
};
</script>

<style scoped>
.el-carousel__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>